import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'react-bootstrap-button-loader';
import { Row, Col } from 'react-bootstrap';
import { push } from 'react-router-redux';
import { reduxForm } from 'redux-form';
import { AdvertiserApi } from '../../../../api';
import { setLoader, removeLoader } from '../../../../actions';
import { convertDollarsToMills } from '../../../../utils/helpers/currency';
import CampaignDetails from '../../../../components/advertisers/campaigns/create/CampaignDetails';

class New extends Component {
  state = { 
    campaignJobsTable: {},
  }

  onFormSubmit(values) {
    const {
      dispatch,
      account,
    } = this.props;

    const campaign = { ...values,
      budget: convertDollarsToMills(values.budget),
      bid: convertDollarsToMills(values.bid),
      bid_type: 'cpc',
      status: 'active'
    };

    const params = { account_id: account.uuid };

    dispatch(setLoader('CampaignForm'));

    dispatch(AdvertiserApi.actions.standardCampaignCreate.post(params, campaign, (error, success) => {
      dispatch(removeLoader('CampaignForm'));
      if (success) {
        const campaignId = success.data.id;
        dispatch(push(`/advertiser/home/accounts/${account.slug}/campaigns/${campaignId}`));
      }
    }));
  }

  setCampaignTableRef(ref) {
    this.setState({ campaignJobsTable: ref });
  }

  handleRedirectToWizard() {
    const { dispatch, account } = this.props;
    dispatch(push(`/advertiser/home/accounts/${account.slug}/campaigns/wizard`));
  }

  render() {
    const { isLoading, handleSubmit } = this.props;

    return (
      <div>
        <div className='ibox border-bottom border-top'>
          <div className='ibox-title border-bottom'>
            <Row>
              <Col sm={8}>
                <h5>New Campaign</h5>
              </Col>
              <Col sm={4}>
                <Button
                  type='button'
                  bsStyle='success'
                  className='btn-xs pull-right'
                  onClick={this.handleRedirectToWizard.bind(this)}
                >
                  Campaign Wizard
                  </Button>
              </Col>
            </Row>
          </div>
          <div className="ibox-content">
            <form onSubmit={handleSubmit(this.onFormSubmit.bind(this))}>
              <Row>
                <Col md={12}>
                  <CampaignDetails formAction='Create' />
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <Button
                  type='submit'
                  loading={isLoading}
                  bsStyle='primary'
                  className='pull-right'
                  >
                    Create Campaign
                  </Button>
                </Col>
              </Row>
            </form>
          </div>          
        </div>
      </div>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'campaignCreateForm'
});

const mapStateToProps = (state, ownProps) => {
  const { loader, advertiser: { accounts } } = state;
  const { params: { accountSlug } } = ownProps;
  const account = (accounts.data.data || [])
    .filter((w) => w.slug === accountSlug)[0] || {};
  return { isLoading: loader.includes('CampaignForm'), account };
};

export default connect(mapStateToProps)(ResourceForm(New));
